import { useLeadCardContext } from '@app/components/LeadCard/context';
import { MessagesSkeleton } from '@app/components/LeadCard/ui/MessagesSkeleton';

import { LeadMessageList } from './components/LeadMessageList';

import type { FC } from 'react';

import './MessageHistory.scss';

export const MessageHistory: FC = () => {
  const { isMessagesLoading, leadMessageHistoryError, refetchLeadHistory } =
    useLeadCardContext();

  if (leadMessageHistoryError) {
    return (
      <div className="MessageHistory">
        <div className="MessageHistory__error">
          <p className="MessageHistory__error-text">
            Не удалось загрузить историю сообщений
          </p>
          <button
            type="button"
            className="MessageHistory__retry"
            onClick={() => void refetchLeadHistory()}
          >
            Повторить
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="MessageHistory">
      <LeadMessageList />
      {isMessagesLoading && (
        <div className="MessageHistory__skeleton">
          <MessagesSkeleton />
        </div>
      )}
    </div>
  );
};
